import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Fab,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { CategoriesFormType } from "../../types/entitiesModel";
import { ERROR_MESSAGE, OK_MESSAGE } from "../../utils/Constants";
import { CheckCircleOutline } from "@mui/icons-material";
import { messageType } from "../../types/otherTypes";
import { useNavigate } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { AuthContext } from "../../context/AuthContext";


const CreateCategory: React.FC = () => {
  const { token } = React.useContext(AuthContext) || {};
  const navigate = useNavigate();

  const [formState, setFormState] = React.useState<CategoriesFormType>({
    name: "",
    age: 0,
    description: "",
  });

  const [message, setMessage] = React.useState<messageType>({
    message: "",
    type: OK_MESSAGE, // can change
  });

  /**
   * To handle form data
   * 
   * @param event 
   */
  const handleChangeForm = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setFormState((prevState) => ({
      ...prevState,
      [name]: name === "age" ? Number(value) : value,
    }));
  };

  const handleBackView = () => {
    navigate("/admin/categories");
  };

  /**
   * Send data to api, to save the category
   */
  const handleSubmit = async () => {
    const requestBody = {
      name: formState.name,
      age: formState.age,
      description: formState.description,
    };

    try {
      const options = {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      };

      const response = await fetch("/api/categories", options);

      if (response.ok) {
        const responseData = await response.json();

        setMessage({
          message: `Success: ${
            responseData.messages || "Data enviada con éxito"
          }`,
          type: OK_MESSAGE,
        });

        setTimeout(() => {
          navigate("/admin/categories");
        }, 1000);
      } else {
        const errorData = await response.json();
        setMessage({
          message: `Error: ${errorData.message || "Algo ha ido mal"}`,
          type: ERROR_MESSAGE,
        });
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setMessage({
          message: `Error: ${error.message || "Ha ocurrido un error inesperado"}`,
          type: ERROR_MESSAGE,
        });
      } else {
        setMessage({ message: "Error: Error desconocido", type: ERROR_MESSAGE });
      }
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0}>
        {message.message !== "" &&
          (message.type === OK_MESSAGE ? (
            <Alert
              icon={<CheckCircleOutline fontSize="inherit" />}
              severity="success"
              sx={{
                mx: "auto",
                mb: 2,
                width: "95%",
              }}
            >
              {message.message}
            </Alert>
          ) : (
            <Alert
              sx={{
                m: "auto",
                mb: 2,
                width: "95%",
              }}
              severity="error"
            >
              {message.message}
            </Alert>
          ))}
        <Fab
          color="primary"
          variant="extended"
          sx={{
            mr: 1,
            mb: {
              xs: 1,
              sm: 0,
              lg: 0,
            },
            ml: 2,
          }}
          onClick={handleBackView}
        >
          <KeyboardDoubleArrowLeftIcon />
          <Typography
            sx={{
              ml: 1,
              textTransform: "capitalize",
            }}
          >
            {"Tabla de categorias"}
          </Typography>
        </Fab>
        <Grid item lg={12} md={12} xs={12}>
          <div>
            <Card
              variant="outlined"
              sx={{
                p: 0,
              }}
            >
              <Box
                sx={{
                  padding: "15px 30px",
                }}
                display="flex"
                alignItems="center"
              >
                <Box flexGrow={1}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    Creación de nueva categoria
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <CardContent
                sx={{
                  padding: "30px",
                }}
              >
                <form>
                  {/* Nombre e email */}
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="nombre"
                        label="Nombre"
                        variant="outlined"
                        placeholder="Nombre"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="name"
                        onChange={(e) => handleChangeForm(e)}
                      />
                      <TextField
                        id="age"
                        label="Edad"
                        type="number"
                        variant="outlined"
                        placeholder="Edad"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="email"
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Grid>
                    {/* Contraseña y rol de usuario */}
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="description"
                        label="Descripción"
                        type="text"
                        variant="outlined"
                        placeholder="Descripción"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="description"
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Button
                      onClick={() => {
                        handleSubmit();
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Enviar
                    </Button>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default CreateCategory;
